import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { Card, CardActions, CardMedia, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { todaysTasks, completeTask, getUsers, baseUrl } from '../../api/APIServices';
import { API_STATUS, TASKS_FROM_WEB } from '../../constants';
import questionnaire from '../../assets/images/instruction.png';
import exercise from '../../assets/images/exerciseVideo.png';
import edu from '../../assets/images/education_.png';
import play from '../../assets/images/play.jpg';
import no_image from '../../assets/images/no_image.jpg';
import Video from './TaskSetup/Video';
import Questionnaire from './TaskSetup/Questionnaire';
import InitialClinic from './TaskSetup/InitialClinic';
import UserExerciseList from './Exercise/UserExerciseList';
import UserEducationList from './Education/UserEducationList';
import UserQuestionnaire from './Questionnaire/UserQuestionnaire';
import Featured from './Featured/Featured';
import HomeCard from './HomeCard/HomeCard';
import Dashboardcard from './HomeCard/DashboardCard';
import Footer from './Footer/Footer';

function Content() {

    const dispatch = useDispatch();

    const { t } = useTranslation('global');
    const [cardDetails, setCardDetails] = useState(false);
    const [card, setCard] = useState('');

    const { status, tasks, isCompleteTask } = useSelector((state) => state.todaysTasks)
    const userInfo = JSON.parse(localStorage.getItem('userInfo'));
    // console.log(userInfo, 'userInfo==============')

    useEffect(() => {
        getProgress(userInfo?.userId);
    }, [])


    const [progress, setProgress] = useState({});

    const getProgress = async (userId) => {
        const res = await fetch(`${baseUrl}/user?userId=${userId}`, {
            method: "GET",
            headers: {
                "authorization": `${localStorage.getItem('token')}`,
                "Content-Type": "application/json",
            },
        });

        const result = await res.json();
        setProgress({
            totalProgress: result?.totalProgress,
            weekProgress: result?.weekProgress
        })
        console.log(result, 'result=======')
    }
    const navigate = useNavigate();

    useEffect(() => {
        dispatch(todaysTasks());
    }, []);

    useEffect(() => {
        if (isCompleteTask) {
            console.log('IS_COMPLETE..', isCompleteTask)
            dispatch(todaysTasks());
        }
    }, [isCompleteTask]);

    const handleCompleteTask = (taskId) => {
        dispatch(completeTask({ taskId: taskId }))
    }

    const getThumnail = (type) => {
        switch (type) {
            case 'video':
                return play
            case 'questionnaire':
                return questionnaire
            case 'exercise':
                return exercise
            case 'education':
                return edu
            default:
                return no_image
        }
    }

    const handleCardClick = (card) => {
        setCard(card)
        setCardDetails(true);
    }

    const handleCB = () => {
        setCardDetails(false);
        setCard('')
    }

    if (status === API_STATUS.PENDING || status === API_STATUS.IDEL) {
        return <h2>{t('loading')}</h2>
    }

    if (status === API_STATUS.ERROR) {
        return <h2>Oops!! Something went wrong</h2>
    }


    return (
        <div>
            <div style={{ marginTop: 30, marginLeft: 20 }}>
                <h3 component={'span'} style={{ textAlign: 'left' }}>{tasks?.headers?.homepage}</h3>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', }}>
                {Object.keys(tasks).length === 0 && <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', width: '100%' }}>
                    <h1 style={{ padding: 20, margin: 10 }}>

                        You have successfully completed all the tasks.
                    </h1>
                </div>}
                <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', width: '100%' }}>
                    {tasks && tasks?.setup && tasks?.setup.map((task, index) => {
                        if (TASKS_FROM_WEB.includes(task.type)) {
                            return (
                                <div key={index} style={{ flex: '1 1 200px', margin: '0.5rem' }}>
                                    {task.type === 'video' && <Video task={task} />}
                                    {task.type === 'questionnaire' && <Questionnaire handleCompleteTask={handleCompleteTask} task={task} />}
                                    {task.type === 'message' && <InitialClinic task={task} />}
                                </div>
                            );
                        }
                        return null;
                    })}

                    {/* Cards for today's tasks */}
                    {!cardDetails && tasks && Object.keys(tasks).includes('education') && (
                        // <Card
                        //     size='small'
                        //     onClick={() => navigate('/Education', { state: { education: tasks.education } })}
                        //     sx={{ margin: '0.5rem', width: 'calc(25% - 1rem)' }}>
                        //     <CardMedia
                        //         component="img"
                        //         alt="Education"
                        //         image={getThumnail('education')}
                        //     />
                        //     <CardActions sx={{ paddingBottom: 0, backgroundColor: '#015681', color: 'white', justifyContent: 'center' }}>
                        //         <Typography>{`Education`}</Typography>
                        //     </CardActions>
                        // </Card>
                        <HomeCard title={t('education')} id="edu" img={getThumnail('education')} data={tasks.education} desc={t('listOfAdio')} />

                    )}

                    {!cardDetails && tasks && Object.keys(tasks).includes('exercises') && (
                        // <Card
                        //     size='small'
                        //     onClick={() => navigate('/Exercise', { state: { exercise: tasks.exercises } })}
                        //     sx={{ margin: '0.5rem', width: 'calc(25% - 1rem)' }}>
                        //     <CardMedia
                        //         component="img"
                        //         alt="Exercise"
                        //         image={getThumnail('exercise')}
                        //     />
                        //     <CardActions sx={{ paddingBottom: 0, backgroundColor: '#015681', color: 'white', justifyContent: 'center' }}>
                        //         <Typography>{`Exercise`}</Typography>
                        //     </CardActions>
                        // </Card>
                        <HomeCard title={t('exercise')} id="exe" img={getThumnail('exercise')} data={tasks.exercises} desc={t('listOfVideo')} />

                    )}
                    {/* <HomeCard title={`Questionnaire`} img={getThumnail('questionnaire')} /> */}

                    {!cardDetails && tasks && Object.keys(tasks).includes('questionnaire') && (
                        <HomeCard title={t('questionnaire')} id="que" img={getThumnail('questionnaire')} handleCardClick={handleCardClick} desc={t('feeling')} />
                        // <Card
                        //     size='small'
                        //     onClick={() => handleCardClick('questionnaire')}
                        //     sx={{ margin: '0.5rem', width: 'calc(25% - 1rem)' }}>
                        //     <CardMedia
                        //         component="img"
                        //         alt="Questionnaire"
                        //         image={getThumnail('questionnaire')}
                        //     />
                        //     <CardActions sx={{ paddingBottom: 0, backgroundColor: '#015681', color: 'white', justifyContent: 'center' }}>
                        //         <Typography>{`Questionnaire`}</Typography>
                        //     </CardActions>
                        // </Card>
                    )}
                    {!cardDetails && tasks && Object.keys(tasks).includes('questionnaire') && (
                        <Dashboardcard progress={progress} />
                        // <Card
                        //     size='small'
                        //     onClick={() => handleCardClick('questionnaire')}
                        //     sx={{ margin: '0.5rem', width: 'calc(25% - 1rem)' }}>
                        //     <CardMedia
                        //         component="img"
                        //         alt="Questionnaire"
                        //         image={getThumnail('questionnaire')}
                        //     />
                        //     <CardActions sx={{ paddingBottom: 0, backgroundColor: '#015681', color: 'white', justifyContent: 'center' }}>
                        //         <Typography>{`Questionnaire`}</Typography>
                        //     </CardActions>
                        // </Card>
                    )}




                    {/* Conditional rendering based on cardDetails */}
                    {cardDetails && tasks.exercises && card === 'exercises' && (
                        <UserExerciseList handleCB={handleCB} exercise={tasks.exercises} />
                    )}
                    {cardDetails && tasks.education && card === 'education' && (
                        <UserEducationList handleCB={handleCB} education={tasks.education} />
                    )}
                    {cardDetails && tasks.questionnaire && card === 'questionnaire' && (
                        <UserQuestionnaire
                            task={tasks.questionnaire[0]}
                            handleCB={handleCB}
                            handleCompleteTask={handleCompleteTask}
                            savebutton={false}
                            setCardDetails={setCardDetails}
                        />
                    )}
                </div>


            </div>
            {/* <Footer /> */}
        </div>

    )
}

export default Content